export default __webpack_public_path__ + "static/media/IC00034-sciences.cb9f544b.svg";